/* eslint-disable react/prop-types */
import React from 'react';
import { Helmet } from 'react-helmet';
import { Box, Typography, Grid } from '@mui/material';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorFallback from 'components/error-fallback';
import OverallCount from './OverallCount';
// import ProvisionedServices from './ProvisionedServices';
import ProvisionedResources from './ProvisionedResources';
import ApplicationOnboarded from './ApplicationOnBoard';
import OrderCreationTrend from './OrderCreationTrend';
import dashboardStyle from './style';

const Dashboard = () => (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
        <Helmet>
            <title>Dashboard - DevX Infra</title>
        </Helmet>
        <Box sx={dashboardStyle.dashboard_wrapper}>
            <Box sx={dashboardStyle.box_wrapper}>
                <Box sx={dashboardStyle.box_title}>
                    <Typography variant="h4" sx={dashboardStyle.dashboard_title}>
                        DEVX INFRA DASHBOARD
                    </Typography>
                </Box>
                <Box sx={dashboardStyle.dashboard_container}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <OverallCount />
                        </Grid>
                        <Grid item xs={6}>
                            <ApplicationOnboarded />
                        </Grid>
                        <Grid item xs={6}>
                            <ProvisionedResources />
                        </Grid>
                        <Grid item xs={12}>
                            <OrderCreationTrend />
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </Box>
    </ErrorBoundary>
);

export default Dashboard;
